export const segments = [
  { code: "TECH", name: "Tech", displayName: "Well Tech", color: "#475467" },
  { code: "ENERGY", name: "Energy", displayName: "Well Energy", color: "#15803D" },
  { code: "TELECOM", name: "Telecom", displayName: "Well Telecom", color: "#3157A4" },
  { code: "TI", name: "TI", displayName: "Well TI", color: "#B42318" },
  { code: "INFRA", name: "Infra", displayName: "Well Infra", color: "#C2410C" }
];

export function getInitialSegment() {
  const storedCode = localStorage.getItem("well_active_segment");
  return segments.find(({ code }) => code === storedCode) ?? segments[0];
}
